import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { ProfileItemEntity } from '../../domain/profile-item.entity';

export enum ProfileConfigFormControls {
	Id = 'id',
	Label = 'label',
	Description = 'description',
}

@Injectable()
export class ProfileMetadataForm {
	public form: FormGroup;

	public constructor(protected readonly fb: FormBuilder) {
		this.form = this.fb.group({
			[ProfileConfigFormControls.Id]: [
				{
					value: -1,
				},
			],
			[ProfileConfigFormControls.Label]: [
				'',
				[Validators.required, Validators.maxLength(256)],
			],
			[ProfileConfigFormControls.Description]: [
				'',
				[Validators.maxLength(2500)],
			],
		});
	}

	public extract(): ProfileItemEntity {
		const formValues = this.form.value;
		return ProfileItemEntity.build({
			id: formValues[ProfileConfigFormControls.Id] ?? -1,
			label: formValues[ProfileConfigFormControls.Label] ?? '',
			description: formValues[ProfileConfigFormControls.Description] ?? '',
		});
	}

	public populate(config: Partial<ProfileItemEntity> | null): void {
		if (config === null || config.id === undefined) {
			throw new Error('Invalid entity');
		}
		this.form.patchValue({
			[ProfileConfigFormControls.Id]: config.id,
			[ProfileConfigFormControls.Label]: config?.label ?? '',
			[ProfileConfigFormControls.Description]: config?.description ?? '',
		});
	}
}
